export default "__VITE_ASSET__SOBY$rGH__"